export enum SizeType {
  KB = "KB",
  MB = "MB"
}
